export const Colors = {
  secondary: "#8CC540",
  primary: "##151D30",
  whiteGrey: "#848484",
  white: "#fff",
  grey: "#848484",
  black: "#000000",
  inputGrey: "#EBEBEB",
};
